import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import getPreferredLocale from "./util/getPreferredLocale";

const resources = {
    en: {
        translation: {
            "error": {
                "generic": "Oops, something went wrong!",
                "cannot-create-session": "We were unable to authenticate you. Please reach out to support for assistance.",
                "user-rejected-request": "Please try again by selecting your wallet. If the problem persists, please contact support.",
                "invalid-signature": "We were unable to verify your wallet is owned by you. Please try connecting with a different wallet. If the problem persists, please contact support.",
                "too-many-requests": "There were too many attempts to authenticate with your wallet. Please try again in a minute.",
                "unauthorized": "Your wallet isn't authorized to connect. If you believe this is an error, please contact support."
            }
        }
    },
    pt: {
        translation: {
            "error": {
                "generic": "Oops, algo deu errado!",
                "cannot-create-session": "Não foi possível autenticar você. Por favor, entre em contato com o suporte para assistência.",
                "user-rejected-request": "Por favor, tente novamente selecionando sua carteira. Se o problema persistir, entre em contato com o suporte.",
                "invalid-signature": "Não foi possível verificar que sua carteira é sua. Por favor, tente conectar com uma carteira diferente. Se o problema persistir, entre em contato com o suporte.",
                "too-many-requests": "Houve muitas tentativas de autenticação com sua carteira. Por favor, tente novamente em um minuto.",
                "unauthorized": "Sua carteira não está autorizada a se conectar. Se você acredita que isso é um erro, entre em contato com o suporte."
            }
        }
    },
    es: {
        translation: {
            "error": {
                "generic": "Oops, algo salió mal!",
                "cannot-create-session": "No fue posible autenticarle. Por favor, contacte al soporte para obtener ayuda.",
                "user-rejected-request": "Por favor, intente nuevamente seleccionando su billetera. Si el problema persiste, contacte al soporte.",
                "invalid-signature": "No fue posible verificar que su billetera es suya. Por favor, intente conectar con una billetera diferente. Si el problema persiste, contacte al soporte.",
                "too-many-requests": "Hubo demasiadas intentos de autenticación con su billetera. Por favor, intente nuevamente en un minuto.",
                "unauthorized": "Su billetera no está autorizada para conectarse. Si cree que esto es un error, contacte al soporte."
            }
        }
    }
}

const locale = getPreferredLocale(navigator);

const initOptions = {
    supportedLngs: ['en', 'pt', 'es'],
    resources,
    lng: locale, // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    fallbackLng: "en",
    interpolation: {
        escapeValue: false // react already safes from xss
    }
}

i18n.use(initReactI18next)
    .init(initOptions).then(() => {
        console.log('i18n initialized', locale);
    }).catch((err) => {
        console.error('i18n initialization error', err);
    });

export default i18n;